// extracted by mini-css-extract-plugin
export default {"movieCards":"Actors_movieCards__sRCjn"};